module.exports = __webpack_public_path__ + "static/media/graph-top.0fcda482.png";